export default __webpack_public_path__ + "static/media/Samira_9781408347188.c6406080.jpg";